module.exports = __webpack_public_path__ + "static/media/success_color.89d1f444.svg";